import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  animation: ${fadeIn} 0.2s ease;
`

export const ModalCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  padding: 40px;
  max-width: 500px;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.colors.border};
  animation: ${slideUp} 0.3s ease;

  @media (max-width: 720px) {
    padding: 30px 20px;
  }
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.danger};
  margin: 0 0 16px;
  font-size: 1.75rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  @media (max-width: 720px) {
    font-size: 1.5rem;
  }
`

export const Message = styled.p`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 20px;
  font-size: 1rem;
  text-align: center;
  line-height: 1.6;
`

export const Countdown = styled.div`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#f59e0b22' : '#f59e0b15')};
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 20px 0;
  text-align: center;
  color: #f59e0b;
  font-weight: 600;
  font-size: 0.95rem;
`

export const UpgradeText = styled.p`
  color: ${({ theme }) => theme.colors.success};
  margin: 20px 0;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 720px) {
    flex-direction: column;
  }
`

export const PrimaryButton = styled(Link)`
  flex: 1;
  padding: 14px 24px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#6366f1' : theme.colors.primary)};
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  text-decoration: none;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#7c3aed' : theme.colors.primaryHover)};
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`

export const SecondaryButton = styled.button`
  flex: 1;
  padding: 14px 24px;
  background: transparent;
  color: ${({ theme }) => theme.colors.textPrimary};
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.surfaceMuted};
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:active {
    transform: scale(0.98);
  }
`
